module.exports = __webpack_public_path__ + "img/hhwhc.70d4265f.png";